import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2fbd1dfa")

_pushScopeId("data-v-2fbd1dfa")
const _hoisted_1 = { class: "sceneBox" }
const _hoisted_2 = { class: "sceneBox-wrap" }
const _hoisted_3 = { class: "sceneBox-title-text" }
const _hoisted_4 = { class: "sceneBox-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isShowTitle)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["sceneBox-title", { "title-tine": _ctx.props.titleLine, "title-tine-none": !_ctx.props.titleLine }]
          }, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.props.titleText), 1)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_a_spin, {
          spinning: _ctx.props.loading
        }, {
          default: _withId(() => [
            _renderSlot(_ctx.$slots, "content")
          ]),
          _: 3
        }, 8, ["spinning"])
      ])
    ])
  ]))
})